import {LookupResponse} from '@wix/ambassador-whois-service/types';

export interface WhoisLookupParams {
  domainName: string;
  token: string;
}

export interface WhoisLookupResponse extends LookupResponse {
  available: boolean;
}

export const WhoisWebLookupEndpoint = '/api/whois/lookup';
